import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import updateData from "../../../hooks/updateData";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import axios from "../../../components/utils/Interceptors";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";
import { Form, Input, Button, Switch, Card, Typography, Row, Col } from "antd";

const { Title } = Typography;

const PaymentMethods = () => {
  const [gateway, setGateway] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const { t } = useTranslation();
  const selectLanguage = i18next.language;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAllGateways = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/getallpaymentsetting`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        const response = await res.data;
        if (response.data) {
          setGateway(response.data);
        }
      } catch (error) {
        toast.error(t("Failed to load payment methods"));
      }
      setLoading(false);
    };

    getAllGateways();
  }, [t, user.token]);

  const setGatewayInfo = (id, key, value) => {
    setGateway((prev) =>
      prev.map((item) =>
        item.setting_id === id ? { ...item, [key]: value } : item
      )
    );
  };

  const updateGateway = async (id, event) => {
    event.preventDefault();
    setLoading(true);

    const data = gateway.find((item) => item.setting_id === id);
    const updData = {
      key_id: data.key_id,
      key_secret: data.key_secret,
      is_enabled: data.is_enabled,
      id: data.setting_id,
    };
    const res = await updateData("vendor/updatepaymentsetting", updData);
    if (res.status_code === 200) {
      toast.success(res.message);
    } else {
      toast.error(res.message || t("Update failed"));
    }
    setLoading(false);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <div className="flex justify-between mb-4">
        <Title level={4}>
          {t("Available")} {t("Payment_Method")}
        </Title>
        <Link to={"/vendor/settings/payment-methods/add"}>
          <button className="btn btn-primary btn-sm text-white" size="small">
            {t("Add Gateway")}
          </button>
        </Link>
      </div>

      <Row gutter={[16, 16]}>
        {gateway.map((gatewayItem) => (
          <Col xs={24} md={12} key={gatewayItem.setting_id}>
            <Card
              
              className="flex flex-col items-center"
              bodyStyle={{ display: "flex", flexDirection: "column", alignItems: "center" }}
            >
              <img
                className="w-28 h-12 object-contain mb-3"
                src={gatewayItem.gateway_image}
                alt={gatewayItem.gateway_name}
                style={{ maxWidth: "112px", maxHeight: "48px", objectFit: "contain" }}
              />
              <Title level={5} className="mb-3">
                {gatewayItem.gateway_name}
              </Title>

              <Form
                layout="vertical"
                style={{ width: "100%" }}
                onSubmitCapture={(e) => updateGateway(gatewayItem.setting_id, e)}
              >
                <Form.Item label={t("Active")} valuePropName="checked">
                  <Switch
                    checked={Boolean(gatewayItem.is_enabled)}
                    onChange={(checked) =>
                      setGatewayInfo(gatewayItem.setting_id, "is_enabled", checked ? 1 : 0)
                    }
                  />
                </Form.Item>

                <Form.Item label={t("Publishable Key")}>
                  <Input
                    value={gatewayItem.key_id}
                    onChange={(e) =>
                      setGatewayInfo(gatewayItem.setting_id, "key_id", e.target.value)
                    }
                    size="small"
                  />
                </Form.Item>

                <Form.Item label={t("Secret Key")}>
                  <Input
                    value={gatewayItem.key_secret}
                    onChange={(e) =>
                      setGatewayInfo(gatewayItem.setting_id, "key_secret", e.target.value)
                    }
                    size="small"
                  />
                </Form.Item>

                <Form.Item style={{ textAlign: "right" }}>
                  <button sunbit="primary" className="btn btn-primary text-white">
                    {t("Save")}
                  </button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PaymentMethods;

